var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Editor',{key:_vm.key,ref:"editorRef",attrs:{"disabled":_vm.disabled,"init":_vm.init},model:{value:(_vm.html),callback:function ($$v) {_vm.html=$$v},expression:"html"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }